import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import ChatStore from '../../../../stores/ChatStore';
import { IconButton } from '../../styled';
import { OperatorOffIcon, OperatorOnIcon } from './AgentButtonStyles';

type InjectedProps = {
  chatStore: ChatStore;
};

type Props = {};

const AgentButton = inject('chatStore')(
  observer((props: Props) => {
    const injected = () => props as InjectedProps;

    const { chatStore } = injected();
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
      const shouldEnable = !chatStore.loading && !chatStore.isEscalating && chatStore.messages.length > 2;
      setEnabled(shouldEnable);
    }, [chatStore.loading, chatStore.isEscalating, chatStore.messages, setEnabled]);

    const handleEscalate = () => {
      if (enabled) {
        setEnabled(false);
        chatStore.sendMessage('', 'escalate-to-agent');
      }
    };

    return <IconButton onClick={handleEscalate}>{enabled ? <OperatorOnIcon /> : <OperatorOffIcon />}</IconButton>;
  }),
);

export default AgentButton;
